import * as PIXI from 'pixi.js'
let currentPixiApp = null
export let pixiApp

const loadAssetsPixi = (pixiStates) =>
  import('./assetsLoad.js')
    .then(({ default: loadAssets }) => {
      return loadAssets(pixiStates)
    })
    .catch((error) => {
      // console.error('Error during assets loading in Pixi:', error)
      throw error
    })

const loadPixiApp = () =>
  import('./appPixi.js')
    .then(({ default: createPixiApp }) => {
      if (currentPixiApp) {
        currentPixiApp.destroyPixi(true)
      }

      pixiApp = createPixiApp()
      currentPixiApp = pixiApp
      // if(!PIXI.utils.isMobile.any) currentPixiApp.app.renderer.resolution = settings.devicePixelRatio
      if(PIXI.utils.isMobile.apple.device){
        currentPixiApp.app.renderer.resolution = 2
      }

      // if(!PIXI.utils.isMobile.any) currentPixiApp.app.stage.scale.set(1/settings.devicePixelRatio)

      return pixiApp
    })
    .catch((error) => {
      // console.error('Error during Pixi.js initialization:', error)
      throw error
    })

const createLoadingBar = () =>
  import('./assetsProgressBar.js')
    .then(({ createProgressBar }) => {
      createProgressBar(currentPixiApp)
    })
    .catch((error) => {
      // console.error('Error loading assestsLoadBar.js:', error)
      throw error
    })

const width =  window.innerWidth
const height = window.innerHeight

const loadGameUI = () =>
  import('./gameUI.js')
    .then(({ createAppUI }) => {
      createAppUI()
     // resizePixiGame(width, height)
      resizePixiApp(width, height)
    })
    .catch((error) => {
      // console.error('Error loading gameUI.js:', error)
      throw error
    })

let gameLogicModule

export const loadGameLogicFunctions = () => {
  if (!gameLogicModule) {
    return import('./gameLogic.js')
      .then((module) => {
        gameLogicModule = module
        return gameLogicModule
      })
      .catch((error) => {
        // console.error('Error loading gameLogic.js:', error)
        throw error
      })
  }

  return Promise.resolve(gameLogicModule)
}

const gameTickerStart = () =>
  loadGameLogicFunctions(gameLogicModule)
    .then((gameLogicModule) => {
      gameLogicModule.startGameTicker()
    })
    .catch((error) => {
      throw error
    })

export const loadPixiAssets = (pixiStates) =>
  loadPixiApp()
    // .then(()=> createLoadingBar())  
    .then(()=> loadAssetsPixi(pixiStates))
    .catch((error) => {
      // console.error('Error loading pixi assets:', error)
    })

export const destroyPixiApp = () => destroyPixiAppliaction()
  // loadGameLogicFunctions(gameLogicModule)
  //   .then((gameLogicModule) => {
  //     gameLogicModule.stopGameTicker()
  //   })
  //   .then(destroyPixiAppliaction)
  //   .catch((error) => {
  //     console.error('Error destroying pixi:', error)
  //   })

function destroyPixiAppliaction () {
  if (currentPixiApp) {
    currentPixiApp.destroyPixi(true)
    currentPixiApp = null
  }
}

export const resizePixiApp = (x, y) => currentPixiApp.resizePixiApp(x, y)

export const init = (pixiStates) =>
  loadPixiApp()
    // .then(() => createLoadingBar())
    .then(() => loadAssetsPixi(pixiStates))
    // .then(() => currentPixiApp.resizePixiApp(500, 300))
    // .then(() => loadGameUI())
    .then(() => gameTickerStart())
    .catch((error) => {
      // console.error('Error during Pixi initialization:', error)
    })

let gameUIModule

export const loadGameUIFunctions = () => {
  if (!gameUIModule) {
    return import('./gameUI.js')
      .then((module) => {
        gameUIModule = module
        return gameUIModule
      })
      .catch((error) => {
        // console.error('Error loading gameUI.js:', error)
        throw error
      })
  }

  return Promise.resolve(gameUIModule)
}
